import {
  Container,
  Stack,
  Box,
  Divider,
  Text,
  HStack,
  SimpleGrid,
  useColorModeValue,
} from "@chakra-ui/react";
import { Fade } from "react-reveal";
import { useEffect, useState } from "react";

export default function Presentations({ color }) {
  const [presentations, setPresentations] = useState([]);

  useEffect(() => {
    fetch("/content/Presentations.md")
      .then((response) => {
        if (!response.ok) throw new Error("Failed to fetch markdown content");
        return response.text();
      })
      .then((mdContent) => {
        const parsedPresentations = parsePresentations(mdContent);
        setPresentations(parsedPresentations);
      })
      .catch((error) => {
        console.error("Error fetching presentations content:", error);
      });
  }, []);

  // Parse the Markdown content to extract presentations
  const parsePresentations = (mdContent) => {
    const presentations = [];
    const lines = mdContent.split("\n");

    for (let i = 0; i < lines.length; i++) {
      if (lines[i].startsWith("- **Title:**")) {
        const title = lines[i].split(":")[1].trim();
        const description = lines[++i].split(":")[1].trim();

        presentations.push({ title, description });
      }
    }

    return presentations;
  };

  // Dynamic colors for light and dark modes
  const bgColor = useColorModeValue("gray.100", "gray.600"); // Light mode: gray.100, Dark mode: gray.600
  const titleColor = useColorModeValue("gray.800", "white"); // Light mode: gray.800, Dark mode: white
  const descriptionColor = useColorModeValue("gray.600", "gray.200"); // Light mode: gray.600, Dark mode: gray.200

  return (
    <Container maxW={"3xl"} id="presentations">
      <Stack
        as={Box}
        textAlign={"center"}
        spacing={{ base: 8, md: 14 }}
        pb={{ base: 20, md: 36 }}
      >
        <Stack align="center" direction="row" px={4}>
          <HStack mx={4}>
            <Text color={`${color}.400`} fontWeight={800}>
              07
            </Text>
            <Text fontWeight={800}>Presentations</Text>
          </HStack>
          <Divider orientation="horizontal" />
        </Stack>
        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={10} px={4}>
          {presentations.map((presentation, index) => (
            <Fade bottom key={index}>
              <Box
                borderWidth="1px"
                borderRadius="lg"
                overflow="hidden"
                bg={bgColor} // Adjust background color based on mode
                shadow="md"
                p={6}
                borderColor={`${color}.400`} // Optional: Border color based on the passed color prop
                transition="transform 0.2s"
                _hover={{ transform: "scale(1.05)" }}
              >
                <Stack spacing={4}>
                  <Text fontSize="xl" fontWeight="bold" color={titleColor}>
                    {presentation.title}
                  </Text>
                  <Text fontSize="sm" color={descriptionColor}>
                    {presentation.description}
                  </Text>
                </Stack>
              </Box>
            </Fade>
          ))}
        </SimpleGrid>
      </Stack>
    </Container>
  );
}
